import { formComponentClasses } from "../../styles/componentClasses";

export function FormGrid(params: { children: any }) {
  return (
    <div className={formComponentClasses.grid}>
      {params.children}
    </div>
  );
}
